import React, { ReactElement, useEffect } from 'react';
import {
  Loader, Text, usePerPageValueFromUrl,
} from 'idsk-react-components';
import { MobilePerPageSelect, Pagination, useResponsiveContext } from 'slovlex-idsk-react-components';
import { useSearchParams } from 'react-router-dom';
import useSledovanyLegislativnyMaterialList from './hooks/useSledovanyLegislativnyMaterialList';
import { defaultPerPageValue, perPageDataArray } from '../../../constants/PaginationPerPageConstants';
import getPaginationTotalLabel from '../../../function/getPaginationTotalLabel';
import SledovanyLegislativnyMaterialListTable from './component/SledovanyLegislativnyMaterialListTable';
import FilterInput from '../../FilterInput';
import './sledovanyLegislativnyMaterialList.scss';
import routes from '../../../routing/routes';

interface Props {
  setPageStatus?: (status: number) => void;
}

const SledovanyLegislativnyMaterialList = ({ setPageStatus }: Props): ReactElement => {
  const { perPageValue } = usePerPageValueFromUrl('perPage', perPageDataArray, defaultPerPageValue);
  const [searchParams, setSearchParams] = useSearchParams();
  const {
    legislativnyMaterialPage,
    pageNumber,
    requestStatus,
    searchText,
    reloadMaterialPage,
  } = useSledovanyLegislativnyMaterialList();
  const { isSmallScreen } = useResponsiveContext();

  useEffect(() => {
    setPageStatus(requestStatus.responseCode);
  }, [requestStatus.responseCode, setPageStatus]);

  if (!legislativnyMaterialPage) {
    return <Loader loading={requestStatus.loading} />;
  }

  if (legislativnyMaterialPage.totalElements === 0 && !searchText) {
    return (
      <>
        <FilterInput filterParam={searchText} label="Zadajte číslo LP alebo názov" route={routes.procesy.sledovane} />
        <Loader loading={requestStatus.loading}>
          <Text type="p" size="l" className="text-center">V súčasnosti nesledujete žiadny
            legislatívny proces.
          </Text>
        </Loader>
      </>
    );
  }

  if (legislativnyMaterialPage.totalElements === 0) {
    return (
      <>
        <FilterInput filterParam={searchText} label="Zadajte číslo LP alebo názov" route={routes.procesy.sledovane} />
        <Loader loading={requestStatus.loading}>
          <Text type="p" size="l" className="text-center">Nenašli sa žiadne záznamy.</Text>
        </Loader>
      </>
    );
  }

  return (
    <>
      <FilterInput filterParam={searchText} label="Zadajte číslo LP alebo názov" route={routes.procesy.sledovane} />
      {isSmallScreen && perPageDataArray.length > 0 && (
      <div className="per-page-select">
        <MobilePerPageSelect
          onRecordsPerPageChange={(value) => {
            const updatedSearchParams = new URLSearchParams(searchParams.toString());
            updatedSearchParams.set('perPage', value.toString());
            setSearchParams(updatedSearchParams.toString());
          }}
          recordsPerPage={perPageDataArray}
          perPageValue={perPageValue}
          totalText={getPaginationTotalLabel(legislativnyMaterialPage, pageNumber, 'Procesy')}
        />
      </div>
      )}
      <Loader loading={requestStatus.loading}>
        <>
          <SledovanyLegislativnyMaterialListTable
            legislativnyMaterialPage={legislativnyMaterialPage}
            reloadMaterialPage={reloadMaterialPage}
          />
          <Pagination
            hideTotal
            number={pageNumber}
            size={legislativnyMaterialPage.size}
            totalElements={legislativnyMaterialPage.totalElements}
            onRecordsPerPageChange={(value) => {
              const updatedSearchParams = new URLSearchParams(searchParams.toString());
              updatedSearchParams.set('perPage', value.toString());
              setSearchParams(updatedSearchParams.toString());
            }}
            recordsPerPage={perPageDataArray}
            perPageValue={perPageValue}
          />
        </>
      </Loader>
    </>
  );
};

export default SledovanyLegislativnyMaterialList;
